import { PageMallSkuDetail, ProductBuyStatusEnum } from 'libs/types';
import { Fragment } from 'react';
import { splitNum } from '@/libs/utils';
import useDetailPriceAndAgreement from './useDetailPriceAndAgreement';

type ProductDetailSalePriceProps = {
  skuDetail: PageMallSkuDetail;
  selectTradeAgreement: TradeAgreementInfo;
  productStatus: ProductBuyStatusEnum;
};
export default function ProductDetailSalePrice({
  skuDetail,
  selectTradeAgreement,
}: ProductDetailSalePriceProps) {
  const [integer, faction] = splitNum(skuDetail.salesPrice);
  const { isThePriceDisplayed } = useDetailPriceAndAgreement(
    skuDetail,
    false,
    selectTradeAgreement,
  );

  return (
    <Fragment>
      {!isThePriceDisplayed.display ? (
        isThePriceDisplayed.reason
      ) : (
        <>
          <span className="rmb">￥</span>
          {skuDetail.salesPrice != null ? (
            <Fragment>
              <span className="priceNum priceBig">{integer}</span>
              <span className="priceNum">.{faction}</span>/{skuDetail.unitName ?? ''}
            </Fragment>
          ) : (
            `--/${skuDetail.unitName ?? ''}`
          )}
        </>
      )}
      <style jsx>
        {`
          .rmb {
            font-weight: bold;
          }
          .priceNum {
            font-family: "wowbold";
          }
          .priceBig {
            font-size: 25px;
          }
        `}
      </style>
    </Fragment>
  );
}
